const getters = {
  getPolicies: (state) => state.policies,
  getPolicy: (state) => state.policy,
  getClaims: (state) => state.claims,
  getClaim: (state) => state.claim,
  getPoliciesMeta: (state) => state.policiesMeta,
  getClaimsMeta: (state) => state.claimsMeta,
  getClaimsHistoriesPolicy: (state) => state.claimsHistoriesPolicy,
  getClaimsHistoriesClaim: (state) => state.claimsHistoriesClaim,
  getPartners: (state) => state.partners,
  getProducts: (state) => state.products,
  getProductCategories: (state) => state.productCategories,
  getUploadProgress: (state) => state.uploadProgress,
  getTemplateUrl: (state) => state.templateUrl,
};

export default getters;
